export enum Channel {
    purl = 1,
    facebook = 2,
    twitter = 3,
    email = 4,
}